(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["as-cl-0053"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function openPopup(closest) {
      const popup = closest.querySelector('.cl-0053');

      const active = closest.querySelector('.cl-0033-item.active');
      const value = parseInt(active.dataset.value);

      const qt = popup.querySelector('.cl-0053-add span');
      const percent = popup.querySelector('.cl-0053 h1 span');

      qt.innerHTML = value + 1;

      switch (value) {
        case 1:
          percent.innerHTML = '3%';
          break;
        case 2:
          percent.innerHTML = '5%';
          break;
        default:
          break;
      }

      popup.classList.add('visible');
    }

    function closePopup(closest) {
      const btn = closest.querySelector('.product-page--main-content .product-form--add-to-cart');
      btn.click();

      const popup = closest.querySelector('.cl-0053');
      popup.classList.remove('visible');
    }

    let popupClosed = true;
    const openBtns = document.querySelectorAll('.product-page--main-content .product-form--add-to-cart');
    openBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const closest = btn.closest('.product-page--main-content');

        const active = closest.querySelector('.cl-0033-item.active');
        const value = parseInt(active.dataset.value);

        if (popupClosed && value < 3) {
          e.preventDefault();

          openPopup(closest);

          popupClosed = false;
        } else {
          popupClosed = true;
        }
      });
    });

    const closeBtns = document.querySelectorAll('.cl-0053-overlay, .cl-0053-close, .cl-0053-exit');
    closeBtns.forEach((b) => {
      b.addEventListener('click', () => {
        const closest = b.closest('.product-page--main-content');
        closePopup(closest);
      });
    });

    const addBtns = document.querySelectorAll('.cl-0053-add');
    addBtns.forEach((addOne) => {
      addOne.addEventListener('click', () => {
        const closest = addOne.closest('.product-page--main-content');

        const active = closest.querySelector('.cl-0033-item.active');
        const value = parseInt(active.dataset.value);

        if (value < 3) {
          const btn = closest.querySelector(`.cl-0033-item[data-value="${value + 1}"]`);
          btn.click();
        }

        setTimeout(closePopup(closest), 50);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
